import { BasePresenter } from '../base/base.presenter';
import { useSelector } from 'react-redux';
import { Enums, String, Utilities, Dictionary, Constants } from '@utils';
import { ILang } from '@models/*';
import { dxDataGridColumn } from 'devextreme/ui/data_grid';
import { IProaService, ProaService } from '@services/proyecta/proa-form.service';
import { IProaDetails } from '@interfaces/screens/detail-proa-summary.interface';
import { IDataGridOptions } from "devextreme-react/data-grid";

interface IFilter{
    active: boolean;
    value: string;
    dataField: string;
}
interface IFilters{
    name: IFilter;
    financer: IFilter;
    interventionLine: IFilter;
    projectCode: IFilter;
    country: IFilter;
}
interface IDocumentDetails {
    state:{
        setDataColumns(data:any):void;
        setDataSource(data:any):void;
        setDataMasters(data:any):void;
        setDataFilters(data:any):void;
        filters:IFilters;
        masters:any;
    }
}
class DocsProyectaPresenter extends BasePresenter<IDocumentDetails> { 
    private service: IProaService;
    public columnMaster: any;
    public formMasters: any;
    public dataSource: any;
    public currentLang: ILang;
    public currentLabels: Dictionary<string, string>;

    constructor(view:any) {
        super(view);
        this.currentLang = useSelector(this.context.sessionStore.selectLang);
        this.formMasters = useSelector(this.context.proaStore.selectFormMasters);
        this.currentLabels = useSelector(this.context.sessionStore.selectLabels);
        this.service = new ProaService();
    }

    public async getInfo(){
        if(!this.formMasters) this.dispatcher(this.context.proaStore.getAllFormMasters());
    }

    public unSetLoading = () => {
        this.dispatcherUnsetSetLoading();
    }

    public initialize = async () => {
        this.getfilterData(Constants.FiltersFormats.ONLY_FILES);        
        this.view.state.setDataMasters(this.formMasters);   
        this.view.state.setDataFilters({
            name:{ active:false, dataField:String.Empty, value: String.Empty},
            financer:{ active:false, dataField:String.Empty, value: String.Empty},
            interventionLine:{ active:false, dataField:String.Empty, value: String.Empty},
            projectCode:{ active:false, dataField:String.Empty, value: String.Empty},
            country:{ active:false, dataField:String.Empty, value: String.Empty}
        });   
    }

    public getMastersAndColumns = async () =>{  
        this.columnMaster = await this.service.getDefinitionColumnsProaDocuments(this.currentLang.id);
        this.getColumns();
        this.initialize();
    }

    public getGridProps(){
        return <IDataGridOptions> {
            filterPanel: { visible: false },
            filterRow: { visible: false },
            headerFilter: { visible: false},
            columnChooser: { enabled: false },
            onToolbarPreparing: null,
            export: {
                excelFilterEnabled: false, 
                enabled: false
            },
            columnMinWidth: 20,
            sorting: {mode: "single", ascendingText: "asc"},
        }
    }
    private getColumns = () => {        
        const columns = this.columnMaster.values.map( (value:any) =>{
            const column: dxDataGridColumn = {
                dataField: value.Title, 
                dataType: value.TipoCampoProyecta ,
                caption: value.NombreColumna
            }
            return column;            
        });        
        this.view.state.setDataColumns(columns);
        this.view.state.setDataMasters(this.formMasters);
    }
    private mappingDataSource = (data:any) => {
        return data?.map((item: any)=>{  
            const ffccFinancer = this.getTraductionFromMasters(this.formMasters.ffccFinancer, item.PProaFinanciador);
            const ffrrFinancer = this.getTraductionFromMasters(this.formMasters.ffrrFinancer, item.PProaFinanciador);
            const inteventionLine = this.getTraductionFromMasters(this.formMasters.interventionLines, item.PPresLineaInter);
            const country = this.getTraductionFromMasters(this.formMasters.countries, item.PProaPaisRegion);
            const region = this.getTraductionFromMasters(this.formMasters.regions, item.PProaPaisRegion);
            const fileNameSplit = item.File.Name.split('.');
            const fileExtention = fileNameSplit[fileNameSplit.length - 1];
            return {
                ...item,
                fileExtention: fileExtention,
                url: item.EncodedAbsUrl,
                PProaFinanciador: ffccFinancer === undefined ? ffrrFinancer : ffccFinancer,
                PPresLineaInter: inteventionLine,
                PProaPaisRegion: country === undefined ? region : country
            }
        });
    }
    private getTraductionFromMasters = (master: any, value:string) => {
        let result: any;       
        switch(this.currentLang.label){
            case "EN": 
                result = master.find((x:any) => x.OCTAVIANombreEn === value)?.Title || undefined;
                break;       
            case "PT":
                result = master.find((x:any) => x.OCTAVIANombrePT === value)?.Title || undefined;               
                break;
            case "FR":
                result = master.find((x:any) => x.OCTAVIANombreFR === value)?.Title || undefined;               
                break;
            default: 
                result = master.find((x:any) => x.Title === value)?.Title || undefined;
                break;
        }
      
        return result;
    }
    public getProjectCodes = (data:any): [] => {
        const control: any = [];
        const response: any = [];
        data?.forEach((item:any, i: number) => {
            if(control.indexOf(item.OCTAVIADatosGeneralesCodigoProyecto) === -1){
                response.push({
                    id: i,
                    label: item.OCTAVIADatosGeneralesCodigoProyecto
                });
                control.push(item.OCTAVIADatosGeneralesCodigoProyecto);
            }
        });
        return response;
    }
    private getFilterQuery = () => {
        const base = Constants.FiltersFormats.ONLY_FILES;
        let query = String.Empty;

        if(this.view.state.filters.name.active){
            query = `${ query === String.Empty ? base : query } and `
               +`${String.Format(Constants.FiltersFormats.CONTAINT,this.view.state.filters.name.value,this.view.state.filters.name.dataField)}`
        }
        if(this.view.state.filters.financer.active){
            query = `${query === String.Empty ? base : query} and `
             +`${String.Format(Constants.FiltersFormats.EQUAL_TO,this.view.state.filters.financer.dataField,this.view.state.filters.financer.value.trim())}`
        }
        if(this.view.state.filters.interventionLine.active){
            query = `${query === String.Empty ? base : query} and `
                +`${String.Format(Constants.FiltersFormats.EQUAL_TO,this.view.state.filters.interventionLine.dataField,this.view.state.filters.interventionLine.value.trim())}`
        }
        if(this.view.state.filters.projectCode.active){
            query = `${query === String.Empty ? base : query} and `
                +`${String.Format(Constants.FiltersFormats.EQUAL_TO,this.view.state.filters.projectCode.dataField,this.view.state.filters.projectCode.value.trim())}`
        }
        if(this.view.state.filters.country.active){
            query = `${ query === String.Empty ? base : query } and `
                +`${String.Format(Constants.FiltersFormats.EQUAL_TO,this.view.state.filters.country.dataField,this.view.state.filters.country.value.trim())}`
        }
        if(query === String.Empty){
            query = base;
        }
        return query;
    }
    private getfilterData = async (query:string) => {
        const data = await this.service.getFilteredProaFilesToSearch(query);  
        const dataSource = this.mappingDataSource(data);
        this.view.state.setDataSource(Utilities.sortArrayByKey(dataSource, "PProaPaisRegion"));
    }
    public onFilterChange = (data:any, value: string, dataField:string, filter: IFilter) =>{
        let result = value;
        if(data.length > 0 && value != undefined){
            if(data[0].Id != null){
                result = data.find((x:any) => x.Id.toString() === value.toString())?.Title || undefined;
            }else{
                result = data.find((x:any) => x.id.toString() === value.toString())?.label || undefined;
            }
        }

        if(result != undefined && result != String.Empty){
            filter.active = true;
            filter.value = result;
            filter.dataField = dataField;
        }else{
            filter.active = false;
        }
        const query = this.getFilterQuery();
        this.getfilterData(query);
    }
    
}

export default DocsProyectaPresenter;